const TournamentStatus = {
    Finished: 'Finished',
    Active: 'Active',
    Ready: 'Ready'
};
export const { Active, Finished, Ready } = TournamentStatus;
